import AssignUserMenuContainer from "../../features/menus/components/AssignUserMenuContainer";

const AssignUserMenuPage = () => {
  return (
    <div className="page-body">
      <AssignUserMenuContainer />
    </div>
  );
};

export default AssignUserMenuPage;
